import { Card } from 'react-bootstrap'
import TitlePage from 'components/TitlePage'
import { useParams } from 'react-router-dom'
import SolicitudForm from './components/SolicitudForm'
import { useEffect, useState } from 'react'
import SolicitudService from 'services/solicitud.service'
import { pick } from 'lodash'
import { useDispatch } from 'react-redux'
import { setHttpMessage } from 'store/messageSlice'
import Loading from 'pages/Loading'
import HttpErrorPage from 'pages/HttpErrorPage'

export default function SolicitudFormPage() {
    const { id } = useParams()
    const dispatch = useDispatch()
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const loadData = async () => {
            setLoading(true)
            const { status, data } = await SolicitudService.getSolicitudToUpdate(id)
            if (status === 200) {
                const destinos = groupDestinos(data.data.solicitudBeneficiarios)
                setData({
                    ...pick(data.data, [
                        'id',
                        'identificador',
                        'objetivo_viaje',
                        'actividades',
                        'fuente_financiamiento',
                        'resolucion',
                        'destinos',
                        'pasajes',
                        'viaticos',
                        'gastos',
                        'invitados',
                        'gastos',
                    ]),
                    destinos,
                })
            } else {
                dispatch(setHttpMessage({ status: status, title: data.message }))
            }
            setLoading(false)
        }
        if (id) {
            loadData()
        } else {
            setData(null)
            setLoading(false)
        }
    }, [id])

    if (loading) {
        return <Loading />
    }
    if (id && !data) {
        return <HttpErrorPage statusCode={404} />
    }

    return (
        <>
            <TitlePage title={id ? 'Editar Solicitud' : 'Registro de Solicitud'} />
            <div className='content align-items-center' style={{ backgroundColor: '#efefef' }}>
                <Card className='w-xl-75' style={{ minHeight: '100%' }}>
                    <SolicitudForm data={data} />
                </Card>
            </div>
        </>
    )
}

const groupDestinos = (solBens) => {
    const groups = {}
    solBens.forEach((s) => {
        if (groups[s.grupo]) {
            groups[s.grupo].push(s)
        } else {
            groups[s.grupo] = [s]
        }
    })
    return Object.values(groups).map((g) => {
        return {
            lugar_viaje: g.length > 0 ? g[0].lugar_viaje : '',
            fecha_salida: g.length > 0 ? g[0].fecha_salida : '',
            fecha_llegada: g.length > 0 ? g[0].fecha_llegada : '',
            code: g.length > 0 ? g[0].grupo : '',
            beneficiarios: g.map((b) => {
                const {
                    apellido_beneficiario,
                    nombre_beneficiario,
                    beneficiario_cargo_id,
                    beneficiario_id,
                    cargo,
                    cargo_id,
                    documento,
                    funcion,
                    origen,
                } = b
                return {
                    id: b.id,
                    apellido_beneficiario,
                    nombre_beneficiario,
                    beneficiario_cargo_id,
                    beneficiario_id,
                    cargo,
                    cargo_id,
                    documento,
                    funcion,
                    origen,
                }
            }),
        }
    })
}
